import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mbeConfigService } from './mbe-config.service';
import {
  SweepExecuteRequest,
  SweepExecuteResponse,
  SweepPreview,
} from '../model/sweep-account';

/**
 * MBengine_ENS Sweep Account API (/swp). Same REST base as other Amber Setup MBE calls. #14973
 */
@Injectable({
  providedIn: 'root',
})
export class SweepAccountService {
  private URL: string;
  headers: HttpHeaders;

  constructor(
    @Inject(mbeConfigService) private config: any,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  previewSweep(spsId: number): Observable<SweepPreview> {
    const headers = this.headers;
    return this.httpClient.get<SweepPreview>(
      `${this.URL}/swp/preview/${spsId}`,
      { headers }
    );
  }

  executeSweep(body: SweepExecuteRequest): Observable<SweepExecuteResponse> {
    const headers = this.headers;
    return this.httpClient.post<SweepExecuteResponse>(
      `${this.URL}/swp/execute`,
      body,
      { headers }
    );
  }
}
